import { useCallback, useState } from "react";

export type UseIncrementerProperties = {
  minimum?: number;
  maximum?: number;
  initialValue?: number;
  initialIsIncrementDisabled?: boolean;
  initialIsDecrementDisabled?: boolean;
};
export const useIncrementer = ({
  minimum,
  maximum,
  initialValue = 0,
  initialIsIncrementDisabled = false,
  initialIsDecrementDisabled = false,
}: UseIncrementerProperties = {}) => {
  const [value, setValue] = useState(initialValue);
  const [isIncrementDisabled, setIsIncrementDisabled] = useState(
    initialIsIncrementDisabled,
  );
  const [isDecrementDisabled, setIsDecrementDisabled] = useState(
    initialIsDecrementDisabled,
  );

  const increment = useCallback(() => {
    setValue((value) => {
      if (!maximum || value < maximum) {
        return value + 1;
      }
      return value;
    });
  }, [maximum]);

  const decrement = useCallback(() => {
    setValue((value) => {
      if (!minimum || value > minimum) {
        return value - 1;
      }
      return value;
    });
  }, [minimum, value]);

  return {
    decrement,
    increment,
    isDecrementDisabled,
    isIncrementDisabled,
    maximum,
    minimum,
    setIsDecrementDisabled,
    setIsIncrementDisabled,
    setValue,
    value,
  };
};
